export const formatPhoneNumber = (number) => {
  let cleanedNumber = ('' + number).replace(/\D/g, '');
  let match = cleanedNumber.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match && match.length >= 5) {
    let intlCode = match[1] ? '+1' : '';
    return intlCode + '(' + match[2] + ')' + match[3] + '-' + match[4];
  }
  return number;
};
